import React, { lazy } from "react";
import { Routes as AllRoutes, Navigate, Route } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";

import PrivateRoute from "./PrivateRoute";
import { useGetWebsiteSettingsQuery } from "../store/permissionsService";
import { websiteSettingsActions } from "../store/websiteSettingsSlice";

const Auth = lazy(() => import("./../pages/Auth"));
const Home = lazy(() => import("./../pages/Home"));
const NotFound = lazy(() => import("./../pages/NotFound"));
const AuthSAML = lazy(() => import("./../pages/AuthSAML"));
const AuthError = lazy(() => import("./../pages/AuthError"));

const Routes = () => {
	const dispatch = useDispatch();
	
	const { data: websiteSettings } = useGetWebsiteSettingsQuery();
	React.useEffect(()=>{
		dispatch(websiteSettingsActions.setSettings(websiteSettings));
	},[websiteSettings]);

	const user = useSelector((state) => state.auth.user);
	let routes = (
		<AllRoutes>
			<Route path="/" element={!user ? <Auth /> : <Navigate to="/home" />} />
			<Route path="/authSAML" element={!user ? <AuthSAML /> : <Navigate to="/home" />} />
			<Route path="/authError/:message" element={<AuthError />} />
			<Route path="/*" element={<PrivateRoute />}>
				<Route path="home" element={<Home />} />
				<Route path="*" element={<NotFound />} />
			</Route>
		</AllRoutes>
	);

	return <main>{routes}</main>;
};

export default Routes;
